export const productStateTabConstants = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
};

export default { productStateTabConstants };
